import React from "react"

export default function Video({ videoNative, posterImage, caption }) {
  return (
    <figure className="video">
      <div className="video__media">
        <video
          src={videoNative}
          preload="none"
          controls
          poster={posterImage}
        ></video>
      </div>
      {caption ? (
        <figcaption className="video__caption">{caption}</figcaption>
      ) : null}
    </figure>
  )
}
